<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aNL9ig/images/cover.jpg?1703868083713" alt="This image is the cover for the book Tarot Café, Volume 4, The Tarot Café"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tarot Café, Volume 4, The Tarot Café
      </h1>
      <p class="bookDescription body article font2">
        <p>The spirit of Shandy visits Pamela's dreams in hopes of reconciling with his sister, Fay, before he leaves the earth forever. With a tragic past of betrayal, cruelty and eventual friendship, Shandy will do whatever it takes to make peace with the sister who's the cause of his unexpected death. Amongst these cries of lost love and unfinished business from visiting spirits, the poignant past of our Tarot Cafe owner unfolds. In a life rich with aiding spirits caught in her human world, is Pamela's only solace found in death?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sang-Sun Park
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tokyopop Verlag
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d77dbc14